<template>
  <div class="nr-progress">
    <progress
      ref="progress"
      class="nr-progress-bar is-queued"
      :max="max"
      :value="value"
    >
      {{ value }}
    </progress>
    <p class="nr-progress-value">
      <slot>{{ value }}</slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'NrProgress',
  props: {
    max: {
      type: Number,
      default: 100
    },
    value: {
      type: Number,
      default: undefined
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/tokens/tokens.scss';

.nr-progress {
  position: relative;
  overflow: hidden;

  &:not(:last-child) {
    margin-bottom: $spacing-24;
  }

  .nr-progress-value {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: $font-size-1;
    line-height: $font-lineheight-1;
    font-weight: $font-weight-regular;
    color: $color-white;
    white-space: nowrap;
  }

  .nr-progress-bar {
    margin-bottom: 0;
    border: none;
    border-radius: $border-radius-large;
    display: block;
    height: $font-lineheight-1;
    overflow: hidden;
    padding: $spacing-none;
    width: 100%;

    &.is-queued::-webkit-progress-value {
      background-color: $color-green-100;
    }

    &.is-progress::-webkit-progress-value {
      background-color: $color-blue-100;
    }

    &.is-error::-webkit-progress-value {
      background-color: $color-red-100;
    }

    &.is-complete::-webkit-progress-value {
      background-color: $color-green-100;
    }

    &.is-warning::-webkit-progress-value {
      background-color: $color-yellow-100;
    }

    &::-webkit-progress-value {
      transition: width 0.5s ease;
    }

    &.is-queued::-moz-progress-bar {
      background-color: $color-green-100;
    }

    &.is-progress::-moz-progress-bar {
      background-color: $color-blue-100;
    }

    &.is-error::-moz-progress-bar {
      background-color: $color-red-100;
    }

    &.is-complete::-moz-progress-bar {
      background-color: $color-green-100;
    }

    &.is-warning::-moz-progress-bar {
      background-color: $color-yellow-100;
    }

    &::-moz-progress-bar {
      transition: width 0.5s ease;
    }
  }
}
</style>
